<template>
    <div class="login-form">
        <div class="login-greeting">{{ $t('LABEL_RESET_PASSOWRD') }}</div>
        <LoginTextInput
            color="apple"
            :errors="errors"
            :dark="true"
            :label="$t('PLACEHOLDER_EMAIL')"
            @enter="submit"
            autocomplete="username"
            icon="mail"
            name="mail"
            style="margin-top: 2rem;"
            v-model.trim="mail"
        />
        <ActionButton
            color="apple"
            :label="$t('LABEL_RESET_PASSWORD_ACTION')"
            :loading="loading"
            @click="submit"
            class="login-form-button"
        />
        <div class="login-actions-row" @click="goBack">
            <span class="login-action">{{ $t('BUTTON_BACK') }}</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            mail: '',
            errors: new this.$Errors(),
            loading: false
        }
    },
    methods: {
        goBack() {
            this.$store.commit('setSidebarForm', 'login')
        },
        submit() {
            if (!this.mail) {
                this.errors.set('mail')
                return
            }
            this.loading = true
            this.$api
                .post('v2/reset', {
                    mail: this.mail
                })
                .then(() => {
                    alert(this.$t('TOAST_MESSAGE_REEST_SUCCESS'))
                    this.$router.push('/')
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.loading = false
                })
        }
    }
}
</script>
<style lang="scss" scoped>
.login-form {
    width: 100%;
    min-width: 250px;
}
.login-action {
    color: $accent-apple !important;
}
.app-language {
    font-size: 0.8rem;
    text-align: center;
    margin-top: 0.25rem;
}
</style>
